export const ZIP_CODE_ATTRIBUTE_ID = "12371860";
export const RESPONDENT_ID_ATTRIBUTE_ID = "1500";
